import { createUseStyles } from 'react-jss';

export default createUseStyles({
  logoContainer: {
    height: '120px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: 'white',
    paddingTop: '16px',
    paddingLeft: '160px',
    paddingRight: '160px',
    '@media(max-width: 1200px)': {
      paddingLeft: '60px',
      paddingRight: '60px',
    },
    '@media(max-width: 900px)': {
      height: '130px',
      paddingLeft: '24px',
      paddingRight: '24px',
    },
  },

  link: {
    backgroundColor: ['white', '!important'],
    color: ['#16181b', '!important'],
    '&:hover': {
      backgroundColor: ['#f8f9fa', '!important'],
    },
    '&.active': {
      backgroundColor: ['#f2f5f9', '!important'],
    },
  },

  rightPanel: {
    display: 'flex',
    alignItems: 'center',
  },

  logo: {
    height: '80px',
    '@media(max-width: 900px)': {
      height: '40px',
    },
  },

  profile: {
    marginLeft: '15px',
    marginRight: '20px',
    '@media(max-width: 900px)': {
      marginLeft: 0,
      marginRight: '5px',
    },
  },

  avatar: {
    width: '48px',
    height: '48px',
    backgroundColor: 'white',
    borderRadius: '50%',
    cursor: 'pointer',
  },

  customerSuccessWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },

  customerSuccessImage: {
    width: '80px',
    height: '80px',
    cursor: 'pointer',
  },

  customerSuccessInfo: {
    fontFamily: '"Manrope", sans-serif',
    fontWeight: 800,
    fontSize: '12px',
    textAlign: 'center'
  },

  contactUsImage: {
    height: '60px',
    cursor: 'pointer',
  },

  mainContentContainer: {
    padding: '72px 160px 48px 160px',
    '@media(max-width: 1200px)': {
      padding: '40px 60px 0 60px',
    },
    '@media(max-width: 900px)': {
      padding: '20px 24px 0 24px',
    },
  },

  contactUsModalContainer: {
    padding: '52px 48px 24px',
    fontSize: '18px',
    fontWeight: '600',
  },

  contactUsModalBtn: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '20px',
    '& > button': {
      width: '45%',
      '@media(max-width: 900px)': {
        width: '100%',
      },
    },
  },
});
